import { useLocation } from 'js/lib/useRouter';

import type { CourseraPlusLandingPage } from 'bundles/coursera-plus-landing-page/__generated__/baseContentfulTypes';
import { indicateRedirectedFromExpired } from 'bundles/coursera-plus-landing-page/contentful/constants';
import type { LandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/PageContext';

import _t from 'i18n!nls/coursera-plus-landing-page';

type Props = Pick<CourseraPlusLandingPage, 'modalForUserWhoUsedUpTheirFreeTrial' | 'modalForUserWhoOwnsCourseraPlus'> &
  Pick<LandingPageExtended, 'userHasCourseraPlusFreeTrial' | 'isCourseraPlusOwner'>;

const usePromoWarningModalMessage = ({
  userHasCourseraPlusFreeTrial,
  isCourseraPlusOwner,
  modalForUserWhoUsedUpTheirFreeTrial,
  modalForUserWhoOwnsCourseraPlus,
}: Props) => {
  const location = useLocation();
  const redirectedFromExpired = location.search.indexOf(indicateRedirectedFromExpired) >= 0;
  const isSelfReferralRedirect = location.query.referralRedirect === 'selfReferral';

  let modalMessage;
  let redirectUrlIfNotEligible;

  if (!userHasCourseraPlusFreeTrial && modalForUserWhoUsedUpTheirFreeTrial) {
    modalMessage = modalForUserWhoUsedUpTheirFreeTrial;
  }
  if (isCourseraPlusOwner && modalForUserWhoOwnsCourseraPlus) {
    modalMessage = modalForUserWhoOwnsCourseraPlus;
    redirectUrlIfNotEligible = '/courseraplus';
  }
  if (redirectedFromExpired) {
    // this is when we view the C+ home instead of the expired page
    modalMessage = _t('Sorry, the offer you tried to view is no longer available');
  }

  if (isSelfReferralRedirect) {
    modalMessage = _t('Sorry, you are not eligible for this promotion.');
  }

  return { modalMessage, redirectUrlIfNotEligible };
};

export default usePromoWarningModalMessage;
